import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { BaseGetModel } from '../domain/base-get-model'
import { SellerOfTheDay } from '../domain/SellerOfTheDay'
import {
  GetBeatmakerContactsResponse,
  ProducerItemType,
  ProducerType,
  UpdateAvatarResponse,
  UpdateWallpaperResponse
} from '../types/producer.type'
import { CoreEnvironmentService } from './core-environment.service'
import { TracksService } from './tracks.service'

@Injectable()
export class ProducerService {
  baseUrl: string

  producer = new BehaviorSubject<ProducerType>(null)

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService,
    private tracksService: TracksService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  getInformation(idOrUserName: number | string): Observable<ProducerType> {
    return this.http.get<ProducerType>(`${this.baseUrl}/web/v1/producers/details?id=${idOrUserName}`)
  }

  getBestProducers(): Observable<BaseGetModel<ProducerItemType>> {
    return this.http.get<BaseGetModel<ProducerItemType>>(`${this.baseUrl}/web/v1/producers`)
  }

  getDaySeller(): Observable<SellerOfTheDay> {
    const resultObservable = this.http.get<SellerOfTheDay>(`${this.baseUrl}/web/v1/producers/dayseller`)
    return resultObservable.pipe(
      map(seller => {
        return seller
      })
    )
  }

  uploadAvatar(file: File) {
    const formData = new FormData()
    formData.append('file', file, file.name)
    return this.http.post<UpdateAvatarResponse>(`${this.baseUrl}/Auth/Users/UpdateAvatarWithResult`, formData)
  }

  uploadWallpaper(file: File) {
    const formData = new FormData()
    formData.append('file', file, file.name)
    return this.http.post<UpdateWallpaperResponse>(
      `${this.baseUrl}/Beatmakers/Beatmakers/UploadWallpaperWithResult`,
      formData
    )
  }

  // for BMTV
  // Контакты заполняются в админке (Настройки битмейкера)
  getBeatmakerContacts(beatmakerId: number) {
    return this.http.get<GetBeatmakerContactsResponse>(
      `${this.baseUrl}/BeatsManagement/BeatsManagement/GetBeatmakerContacts?userId=${beatmakerId}`
    )
  }
}
